export const LABEL_FIRSTNAME = 'Registration.First_name';
export const LABEL_LASTNAME = 'Registration.Last_name';
export const LABEL_LOGIN = 'Registration.Login';
export const LABEL_FIELD_NOT_CONTAIN = 'Registration.The_field_X_may_not_contain';
export const LABEL_FIELD_BETWEEN = 'Registration.The_field_X_must_contain_between_X_and_Y_chars';
export const LABEL_PWD_HELP = 'Registration.PasswordHelp';
export const LABEL_FIELD_INVALID = 'Registration.Field_X_is_invalid';
export const LABEL_EMAIL = 'Registration.Email';
export const LABEL_PASSWORD = 'Registration.Password';
export const LABEL_USERNAME_ALREADY_EXISTS = 'Registration.UsernameAlreadyExists';
export const LABEL_USERNAME_INVALID = 'Registration.UsernameInvalid';
export const LABEL_INTERNAL_DOMAIN = 'Registration.Real_external_address_needed';
export const LABEL_PASSWORD_STRONGER = 'Registration.PasswordStronger';
export const LABEL_PASSWORD_DONT_MATCH = 'Registration.Passwords_dont_match';
export const LABEL_INVALID_EMAIL = 'Registration.Invalid_email_address';
export const LABEL_RECOVERY_HELP = 'Registration.RegistrationRecoveryEmailHelp';
export const LABEL_COOKIE_REQUIRED = 'Registration.The_web_browser_must_accept_cookies';
export const LABEL_ERROR_OCCURED = 'Registration.An_error_has_occured';
export const LABEL_CONTINUE = 'Registration.Continue';
export const LABEL_CONFIRM = 'Registration.Confirm';

export const LABEL_SIGN_UP = 'Registration.Sign_up';
export const LABEL_REGISTRATION_EMAIL_VERIFY_TITLE = 'Registration.RegistrationEmailVerifyTitle';
export const LABEL_REGISTRATION_EMAIL_SENT = 'Registration.RegistrationEmailSent';
export const LABEL_REGISTRATION_INVALID_CODE = 'Registration.RegistrationInvalidCode';
export const LABEL_REGISTRATION_RECOVERY_EMAIL = 'Registration.RegistrationRecoveryEmail';
export const LABEL_REGISTRATION_TERMS = 'Registration.RegistrationTermsTerms';
export const LABEL_REGISTRATION_TERMS_PRIVACY = 'Registration.RegistrationTermsPrivacy';
export const LABEL_REGISTRATION_TERMS_ACCEPT = 'Registration.RegistrationTermsReadAndAccept';

export const LABEL_REGISTRATION_TERMS_PLEASE_ACCEPT = 'Registration.RegistrationTermsPleaseAccept';
export const LABEL_REGISTRATION_TERMS_AGE = 'Registration.RegistrationTermsAge';
export const LABEL_REGISTRATION_TERMS_GDPR = 'Registration.RegistrationTermsGDPR';

export const LABEL_REGISTRATION_DISABLED = 'Registration.RegistrationDisabled';
export const LABEL_REGISTRATION_REFUSED = 'Registration.RegistrationRefused';
export const LABEL_PLEASECONTACT_SUPPORT_LINK = 'Registration.PleaseContactSupportLink';
export const LABEL_REJECT_REASON = 'Registration.RegistrationRefusedReasons';
export const LABEL_THUNDERBIRD_PLEASE_REGISTER_FROM_THUNDERBIRD = 'Registration.Thunderbird_please_register_from_thunderbird';
export const LABEL_THUNDERBIRD_TOKEN_EXPIRED = 'Registration.Thunderbird_token_expired';
export const LABEL_TOO_MANY_ACCOUNTS_FOR_MAILADDRESS = 'Registration.TooManyAccountsForMailAddress';
export const LABEL_PLEASE_UPGRADE_THUNDERBIRD = 'Registration.PleaseUpgradeThunderbird';
export const LABEL_SEND = 'Registration.Send';
export const LABEL_REGISTRATION_ENTER_CODE = 'Registration.RegistrationEnterCode';
export const LABEL_REGISTRATION_CTEMPLAR = 'Registration.CTemplar';

export const LABEL_THUNDERBIRD_REGISTRATION_INTRO_TITLE = 'Registration.Thunderbird_registration_intro_title';
export const LABEL_THUNDERBIRD_REGISTRATION_INTRO = 'Registration.Thunderbird_registration_intro';
export const LABEL_THUNDERBIRD_SIGNUP = 'Registration.Thunderbird_please_register_from_thunderbird';
export const LABEL_LEARN_MORE = 'Registration.Learn_more';
export const LABEL_REAL_EXTERNAL_ADDRESS_NEEDED = 'Registration.Real_external_address_needed';
export const LABEL_YOU_RECEIVED_AN_INVITATION_FROM_GROUP_ADMINISTRATOR_PART1 =
  'Registration.You_received_an_invitation_from_group_administrator_part1';
export const LABEL_YOU_RECEIVED_AN_INVITATION_FROM_GROUP_ADMINISTRATOR_PART2 =
  'Registration.You_received_an_invitation_from_group_administrator_part2';
export const LABEL_I_HAVE_NOT_RECEIVE_THE_CONFIRMATION_EMAIL = 'Registration.I_have_not_receive_the_confirmation_email';
export const LABEL_POSSIBLE_REASONS_FOR_NOT_RECEIVING = 'Registration.Possible_reasons_for_not_receiving';

export const LABEL_EXPIRED_GROUP_INVITATION = 'Registration.Expired_group_invitation';
export const LABEL_REGISTRATION_EMAIL_NOT_RECEIVED = 'Registration.I_have_not_receive_the_confirmation_email';

export const LABEL_REGISTRATION_ENTERED_INVALID_EMAIL = 'Registration.You_entered_an_incorrect_mail_address';
export const LABEL_REGISTRATION_EDIT_EMAIL = 'Registration.Edit_email_address';
export const LABEL_REGISTRATION_EMAIL_SPAM_FOLDER = 'Registration.Our_email_got_in_the_spam_folder';
export const LABE_REGISTRATION_EMAIL_WHITE_LIST = 'Registration.Add_us_to_your_white_list';
export const LABE_REGISTRATION_RESEND_CODE = 'Registration.Resend_code';

export const LABEL_ENGLISH_SELF = 'Common.English_self';
export const LABEL_FRENCH_SELF = 'Common.French_self';
export const LABEL_DUTCH_SELF = 'Common.Dutch_self';
export const LABEL_PORTUGUESES_SELF = 'Common.Portuguese_self';
export const LABEL_SPANISH_SELF = 'Common.Spanish_self';
export const LABEL_ITALIAN_SELF = 'Common.Italian_self';
export const LABEL_GERMAN_SELF = 'Common.German_self';
export const LABEL_RUSSIAN_SELF = 'Common.Russian';

export const LABEL_PASSWORD_RESET = 'Password.Password_reset';
export const LABEL_USERNAME_OR_PRIMARY_EMAIL = 'Password.Username_or_primary_email';
export const LABEL_PASSWORD_RESET_KEY_EXPIRED = 'Password.Password_reset_key_expired';
export const LABEL_PASSWORD_RESET_KEY_INVALID = 'Password.Password_reset_key_invalid';
export const LABEL_PASSWORD_RESET_HELP = 'Password.Password_reset_help';
export const LABEL_RECOVERY_EMAIL = 'Password.Recovery_email';
export const LABEL_PASSWORD_RESET_RECOVERY_EMAIL_HELP = 'Password.Password_reset_recovery_email_help';
export const LABEL_START_OVER = 'Password.Start_over';
export const LABEL_PASSWORD_RESET_DISABLED = 'Password.Password_reset_disabled';
export const LABEL_CONTACT_SUPPORT = 'Password.Contact_support';
export const LABEL_YOUR_PASSWORD_HAS_BEEN_CHANGED = 'Password.Your_password_has_been_changed';
export const LABEL_RECOVERY_EMAIL_MISMATCH = 'Password.Recovery_email_mismatch';
export const LABEL_CODE = 'Password.Code';
export const LABEL_TWO_FACTOR_AUTHENTICATION = 'Password.Two_factor_authentication';
export const LABEL_OPEN_YOUR_TIME_BASED_ONE_TIME_PASSWORD = 'Password.Open_your_Time_based_One_Time_Password';
export const LABEL_ENTER_ONE_OF_YOUR_BACKUP_CODES = 'Password.Enter_one_of_your_backup_codes';
export const LABEL_TOTP_INVALID_CODE = 'Password.TOTP_invalid_code';
export const LABEL_ACCOUNT_DISABLED = 'Password.Your_account_is_disabled';
export const LABEL_PASSWORD_CANT_BE_RESET = 'Password.The_password_can_t_be_reset';
export const LABEL_SERVER_ERROR = 'Common.unexpectedError';
export const LABEL_SERVER_ERROR_TRY_LATER = 'Common.Please_try_again_later';

export const LABEL_CLOSE = 'Common.Close';
